export * from '@aws-amplify/auth';
//# sourceMappingURL=index.mjs.map
